/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eta_Window_MorningInputs */

const en_eta_window_morning = /** @type {(inputs: Eta_Window_MorningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8:00 – 12:00`)
};

const ja_eta_window_morning = /** @type {(inputs: Eta_Window_MorningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8:00 – 12:00`)
};

const fr_eta_window_morning = /** @type {(inputs: Eta_Window_MorningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8h00 – 12h00`)
};

const de_eta_window_morning = /** @type {(inputs: Eta_Window_MorningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8:00 – 12:00`)
};

/**
* | output |
* | --- |
* | "8:00 – 12:00" |
*
* @param {Eta_Window_MorningInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const eta_window_morning = /** @type {((inputs?: Eta_Window_MorningInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eta_Window_MorningInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eta_window_morning(inputs)
	if (locale === "ja") return ja_eta_window_morning(inputs)
	if (locale === "fr") return fr_eta_window_morning(inputs)
	return de_eta_window_morning(inputs)
});